import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';
import { FormsModule } from '@angular/forms';
import { UserListComponent } from '../user-list/user-list.component';
import { ProductChatWindowComponent } from '../product-chat-window/product-chat-window.component';
import { ActivatedRoute } from '@angular/router';
import { decrypt } from '../../service/utils';

@Component({
  selector: 'app-chat-window',
  standalone: true,
  imports: [CommonModule,FormsModule,UserListComponent,ProductChatWindowComponent],
  templateUrl: './chat-window.component.html',
  styleUrl: './chat-window.component.scss'
})
export class ChatWindowComponent {

  selectedUser:any=null;
  orderId:any=null;
  constructor(private http:HttpService,
              public gS:GlobalService,
              private route: ActivatedRoute
  ){
    
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const encryptedOrderId = params['orderId'];
      const realOrderId = decrypt(encryptedOrderId);
      if(realOrderId){
        this.orderId = realOrderId;
      }
    });
  }

  selectUser(event:any){
    this.selectedUser=event;
    this.gS.triggerCommonListner({
      type:'selectUser',
      data:this.selectedUser
    })
  }

}
